import { createFileRoute } from '@tanstack/react-router'

import { ShootGroup } from '@/components/fotograf/knihovna'
import { JellyIcon } from '@/components/icons'
import { AppLink as Link } from '@/components/shell'
import { DEFAULT_VENUE_SLUG, VENUE_LIBRARIES } from '@/mocks/fotograf/knihovna'

export const Route = createFileRoute('/fotograf/knihovna/$venue')({
  head: () => ({ meta: [{ title: 'Podnik · Aplikace Bitez' }] }),
  component: FotografVenueLibrary,
})

function FotografVenueLibrary() {
  const { venue: slug } = Route.useParams()
  // The prototype has one venue's wall built; every tile links to it.
  const library = VENUE_LIBRARIES[slug] ?? VENUE_LIBRARIES[DEFAULT_VENUE_SLUG]

  return (
    <div className="px-4 pt-4 pb-6">
      <Link
        href="/fotograf/knihovna"
        className="-ml-1 flex w-fit items-center gap-1.5 rounded-full px-1 py-1 text-[10px] font-bold tracking-widest text-ink/40 uppercase transition-colors duration-150 hover:text-ink/70"
      >
        <JellyIcon name="arrow-left" className="size-3" />
        Knihovna
      </Link>

      <header className="mt-3 flex items-center gap-3">
        <img
          src={library.avatar}
          alt=""
          width={150}
          height={150}
          className="size-12 shrink-0 rounded-2xl object-cover"
        />
        <div className="min-w-0">
          <h1 className="font-display truncate text-2xl leading-[0.9] uppercase">{library.name}</h1>
          <p className="mt-1 text-[10px] font-semibold text-ink/45">{library.meta}</p>
        </div>
      </header>

      <div className="mt-6 space-y-8">
        {library.shoots.map((shoot, index) => (
          <div
            key={shoot.date}
            className="animate-rise-up"
            style={{ animationDelay: `${index * 90}ms` }}
          >
            <ShootGroup shoot={shoot} />
          </div>
        ))}
      </div>
    </div>
  )
}
